module.exports = __webpack_public_path__ + "fonts/CrimsonText-SemiBold.1607ef7b.ttf";